import { GERMAN_LOCALE } from 'i18n/util/locale'

export const HONOURIFIC_TITLES: Array<App.Title> = [
  'Mr',
  'Mrs',
  'Miss',
  'Ms',
  'Master',
]
export const GERMAN_HONOURIFIC_TITLES: Array<App.Title> = ['Mr', 'Ms']

function isGermanLocale(locale: string): boolean {
  return locale === GERMAN_LOCALE
}

export function getHonourificTitlesForLocale(
  locale: string,
  titles: Array<App.Title> = HONOURIFIC_TITLES,
): Array<App.Title> {
  if (!isGermanLocale(locale)) return titles

  return GERMAN_HONOURIFIC_TITLES.filter((title) => titles.includes(title))
}
